export const load = () => ({
	title: 'Magnetic Storm Windows: Pros and Cons',
	showTitle: true,
});
